import {
  BaseBoxShapeTool,
  BaseBoxShapeUtil,
  HTMLContainer,
  Rectangle2d,
  TLBaseShape
} from "tldraw"

type RulerShape = TLBaseShape<
  'ruler',
  {
    w: number
    h: number
  }
>

export class RulerShapeUtil extends BaseBoxShapeUtil<RulerShape> {
  static override type = 'ruler' as const;

  getDefaultProps(): RulerShape['props'] {
    return {
      w: 400,
      h: 60,
    }
  }

  getGeometry(shape: RulerShape) {
    return new Rectangle2d({
      width: shape.props.w,
      height: shape.props.h,
      isFilled: true,
    })
  }

  component(shape: RulerShape) {
    const { w, h } = shape.props

    const pxPerCm = 50
    const mmPerCm = 10
    const pxPerMm = pxPerCm / mmPerCm

    const padding = 20
    const ticksRegionLength = w - (2 * padding)

    const totalTicks = Math.floor(ticksRegionLength / pxPerMm)

    return (
      <HTMLContainer>
        <div
          style={{
            width: w,
            height: h,
            // background: '#f6e6b4',
            background: 'rgba(246,230,180,0.3)',
            border: '1px solid #444',
            boxSizing: 'border-box',
            // paddingLeft: `${padding}px`,
            // paddingRight: `${padding}px`,
          }}
        >
          <svg width={w} height={h}>
            {Array.from({ length: totalTicks + 1 }).map((_, i) => {
              const x = (i * pxPerMm) + padding
              const isCm = i % 10 === 0
              const isHalfCm = i % 5 === 0

              let tickHeight = h * 0.25
              if (isHalfCm) tickHeight = h * 0.4
              if (isCm) tickHeight = h * 0.6

              return (
                <g key={i}>
                  <line
                    x1={x}
                    y1={0}
                    x2={x}
                    y2={tickHeight}
                    stroke="black"
                    strokeWidth={1}
                  />

                  {isCm && (
                    <text
                      x={x-5}
                      y={h - 10}
                      fontSize={14}
                      fill="black"
                    >
                      {i / 10}
                    </text>
                  )}
                </g>
              )
            })}
          </svg>
        </div>
      </HTMLContainer>
    )
  }

  indicator(shape: RulerShape) {
    return (
      <rect
        width={shape.props.w}
        height={shape.props.h}
      />
    )
  }
}


export const RulerIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="5" width="18" height="10" fill="none" rx="1" stroke="black" strokeWidth="0.8"/>
    <line x1="4" y1="5" x2="4" y2="10" stroke="black" strokeWidth="0.8" />
    <line x1="8" y1="5" x2="8" y2="10" stroke="black" strokeWidth="0.8" />
    <line x1="12" y1="5" x2="12" y2="10" stroke="black" strokeWidth="0.8" />
    <line x1="16" y1="5" x2="16" y2="10" stroke="black" strokeWidth="0.8" />
  </svg>
)

export class RulerTool extends BaseBoxShapeTool {
  static override id = 'ruler'
  static override initial = 'idle'
  shapeType = 'ruler'
}